import React from 'react'
import Carrusel from '../Carrusel'
import { Link } from 'react-router-dom'
import './styles/IntroFeria.css'

const IntroFeria = () => {
  return (
    <div className="trama-feria">
    <div className="grid-intro site-width">
      <div className="intro-content intro-content-feria">
        <span className="feria-date-badge">🎡 Del 17 al 26 de Julio · La Línea de la Concepción</span>
        <h1>Esta Feria, no te quedes sin tu corte</h1>
        <p>Del <b>17</b> al <b>26</b> de Julio nos espera la <b>Feria de La Línea de la Concepción</b> 🎡. Reserva ahora tu cita y llega con estilo. ¡Los huecos vuelan!</p>
        <div className="botones-intro">
          <Link className='reserva-button reserva-button-feria' to="/reservar">Reserva tu cita ahora <img src="/images/abanico.png" alt="Icono" className="abanico-boton-intro"/></Link>
          {/*<a className='wa-button' href="https://wa.me/34655790542"  rel='noreferrer' target="_blank"><img src='/images/whatsapp.svg' alt='Icono'/><p>¿Dudas? Contáctame</p></a>*/}
        </div>
      </div>
      <Carrusel />
    </div>
  </div>
  )
}

export default IntroFeria
